import React, {useState}from 'react';
import dateFormat, { masks, i18n } from "dateformat";
import styles from "./weightLossCardBlock.module.scss";
import WeightLossItemsBlock from './weightLossItemsBlock';
import WeightLossPlansBlock from './weightLossPlansBlock';
import WeightLossCardBlock from './weightLossCardBlock';
import locales from "../../../../content.json";

const WeightLossPage = ({currentWeight, goalWeight, weightType}) => {
    const [checked, setChecked] = useState(true);
    const [weightLossPlanValues, setWeightLossPlanValues] = useState({caloriesBurn: 350, caloriesIntake: 1850, loseWeeklyKg: 0.900, loseWeeklyPounds: 2});
    let [animClass, setAnimClass] = useState(styles.animate_on);

    i18n.monthNames = [
        [locales[window.userLang].i18n_monthNames_1],
        [locales[window.userLang].i18n_monthNames_2],
        [locales[window.userLang].i18n_monthNames_3],
        [locales[window.userLang].i18n_monthNames_4],
        [locales[window.userLang].i18n_monthNames_5],
        [locales[window.userLang].i18n_monthNames_6],
        [locales[window.userLang].i18n_monthNames_7],
        [locales[window.userLang].i18n_monthNames_8],
        [locales[window.userLang].i18n_monthNames_9],
        [locales[window.userLang].i18n_monthNames_10],
        [locales[window.userLang].i18n_monthNames_11],
        [locales[window.userLang].i18n_monthNames_12],
        [locales[window.userLang].i18n_monthNames_full_1],
        [locales[window.userLang].i18n_monthNames_full_2],
        [locales[window.userLang].i18n_monthNames_full_3],
        [locales[window.userLang].i18n_monthNames_full_4],
        [locales[window.userLang].i18n_monthNames_full_5],
        [locales[window.userLang].i18n_monthNames_full_6],
        [locales[window.userLang].i18n_monthNames_full_7],
        [locales[window.userLang].i18n_monthNames_full_8],
        [locales[window.userLang].i18n_monthNames_full_9],
        [locales[window.userLang].i18n_monthNames_full_10],
        [locales[window.userLang].i18n_monthNames_full_11],
        [locales[window.userLang].i18n_monthNames_full_12],
    ];

    const now = new Date();
    const needWeeksKg = Math.round(((currentWeight - goalWeight) / weightLossPlanValues.loseWeeklyKg) * 7);
    const needWeeksPounds = Math.round(((currentWeight - goalWeight) / weightLossPlanValues.loseWeeklyPounds) * 7);

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const weekDate = () => {
        if (weightType === "kg") {
            return addDays(now, needWeeksKg);
        } else {
            return addDays(now, needWeeksPounds);
        }
    }

    const firstDate = dateFormat(now, "dd mmm, yyyy");
    const secondDate = dateFormat(weekDate(), "dd mmm, yyyy");

    function changeWeightLossPlan(event) {
        setChecked(!checked)
        animClass === styles.animate_on ? setAnimClass(styles.animate_off) : setAnimClass(styles.animate_on)   
        if (event.target.id === "button1") {
            setWeightLossPlanValues({caloriesBurn: 350, caloriesIntake: 1850, loseWeeklyKg: 0.900, loseWeeklyPounds: 2})
            setTimeout(() => {
                setAnimClass('')
                setAnimClass(styles.animate_on)
            }, 200);
        } else if(event.target.id === "button2") {
            setWeightLossPlanValues({caloriesBurn: 420, caloriesIntake: 1600, loseWeeklyKg: 1.100, loseWeeklyPounds: 2.4})
            setTimeout(() => {
                setAnimClass('')
                setAnimClass(styles.animate_on)
            }, 200);
        }
    }

    return (
        <div className={styles.weightloss_container}>
            <div className={styles.weightloss_title}>
                {locales[window.userLang].weight_loss_page_title}
            </div>
            <WeightLossCardBlock 
                firstDate={firstDate}
                secondDate={secondDate}
                currentWeight={currentWeight}
                goalWeight={goalWeight}
                weightType={weightType}
                animation={animClass}
            />
            <WeightLossPlansBlock isChecked={checked} changePlan={changeWeightLossPlan}/>
            <WeightLossItemsBlock 
                planDetails={weightLossPlanValues} 
                weightType={weightType}
                date={secondDate}
            />
        </div>   
    )
}

export default WeightLossPage;